export default __webpack_public_path__ + "static/demande.couture.mobile-b0c17113e75228437a5eab1fa44d9d5d.jpg";